import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { ArrowLeft } from "lucide-react";
import { useAuth, formatApiError } from "@/context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LOGO_URL = `${process.env.REACT_APP_BACKEND_URL}/api/static/kpl-logo-color.png`;
const LOGO_WHITE_URL = `${process.env.REACT_APP_BACKEND_URL}/api/static/kpl-logo-white.png`;
const STREAK_URL = "https://customer-assets-jai6qajn.emergentagent.net/job_kpl-league/artifacts/89377fcc3ef00973_image.png";

export default function Register() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await axios.post(`${API}/auth/register`, { name, email, password });
      setUser(data);
      navigate("/");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    }
    setBusy(false);
  };

  return <div className="auth-wrap">
    <img className="auth-streak" src={STREAK_URL} alt="" aria-hidden="true" />
    <Link className="auth-home" to="/" data-testid="register-back-home"><ArrowLeft size={15} /> BACK TO SITE</Link>
    <div className="auth-card">
      <img className="auth-logo" src={LOGO_URL} alt="KPL logo" />
      <h1>Join the league.</h1>
      <p className="auth-sub">Create your fan account — pick your franchise and get ready for Season One.</p>
      {error && <div className="auth-error" data-testid="register-error">{error}</div>}
      <form onSubmit={submit}>
        <div className="auth-field"><label>Name</label><input type="text" required minLength={2} value={name} onChange={(e) => setName(e.target.value)} placeholder="Your name" data-testid="register-name-input" /></div>
        <div className="auth-field"><label>Email</label><input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" data-testid="register-email-input" /></div>
        <div className="auth-field"><label>Password</label><input type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="6+ characters" data-testid="register-password-input" /></div>
        <button className="button button-red auth-submit" type="submit" disabled={busy} data-testid="register-submit-button">{busy ? "Creating…" : "Create account"}</button>
      </form>
      <p className="auth-switch">Already have an account? <Link to="/login" data-testid="go-login-link">Log in</Link></p>
    </div>
  </div>;
}
